<ng-container *ngIf="catFacet$ | async as categories">

    <button *ngIf="categories.length > 0" class="heading" (click)="toggleGroup($event)">
        {{ "plp.subCategories" | cxTranslate }}
        <cx-icon *ngIf='open' [type]="collapseIcon"></cx-icon>
        <cx-icon *ngIf='!open' [type]="expandIcon"></cx-icon>
    </button>
    <div *ngIf="open">
        <a class="category-link" *ngFor="let category of categories | slice: 0:topVisible" #facetValue
        [routerLink]="category.url"  (keydown.space)="openLink($event)">
        <span>
            <span class="label">{{ category.name }}</span>
        </span>
    </a>

    <div class="more">
        <a class="category-link" *ngFor="let category of categories | slice: topVisible:maxVisible"
            [routerLink]="category.url"   (keydown.space)="openLink($event)">
            <span>
                <span class="label">{{ category.name }}</span>
            </span>
        </a>

        <button *ngIf="maxVisible > topVisible " class="cx-action-link" 
            cxFocus="moreorless" (click)="decreaseVisibleValues()">
            {{ 'productList.showLess' | cxTranslate }}
        </button>

        <button *ngIf="maxVisible > 0 && maxVisible < categories.length " class="cx-action-link"
            cxFocus="moreorless" (click)="increaseVisibleValues()">
            {{ 'productList.showMore' | cxTranslate }}
        </button>
    </div>
    </div>
    
</ng-container>